export default class SaleService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getSales (query) {
    return new Promise((resolve, reject) => {
      this.$http.post('sales', query)
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  printSalesRecord (sales) {
    return new Promise((resolve, reject) => {
      this.$http.post('sales/print', { sales })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  getSessionSalesOrders () {
    return new Promise((resolve, reject) => {
      this.$http.get('sales_orders/session')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  saveSalesOrder (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('sales_orders/store', data)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  updateSalesOrder (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`sales_orders/update/${id}`, data)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  deleteSalesOrder (id) {
    return new Promise((resolve, reject) => {
      this.$http.post(`sales_orders/delete/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  getTopItems (number) {
    return new Promise((resolve, reject) => {
      this.$http.get(`sales/items/top-selling/${number}`)
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getSalesByCategory () {
    return new Promise((resolve, reject) => {
      this.$http.get('sales/items/categories')
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getSalesByPaymentMethod () {
    return new Promise((resolve, reject) => {
      this.$http.get('sales/items/payment-methods')
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }
}
